function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 75.877 79.794 H 5.966 C 2.676 79.794 0 77.117 0 73.827 V 24.329 c 0 -3.29 2.676 -5.967 5.966 -5.967 h 69.911 c 3.29 0 5.967 2.677 5.967 5.967 v 49.498 C 81.844 77.117 79.167 79.794 75.877 79.794 z M 5.966 22.362 C 4.882 22.362 4 23.245 4 24.329 v 49.498 c 0 1.085 0.882 1.967 1.966 1.967 h 69.911 c 1.085 0 1.967 -0.882 1.967 -1.967 V 24.329 c 0 -1.084 -0.882 -1.967 -1.967 -1.967 H 5.966 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 75.877 79.794 H 5.966 C 2.676 79.794 0 77.117 0 73.827 c 0 -0.47 0.166 -0.925 0.468 -1.285 l 14.707 -17.536 c 1.629 -1.942 4.016 -3.104 6.55 -3.188 c 2.529 -0.07 4.993 0.917 6.748 2.748 l 0.928 0.968 c 0.978 1.021 2.341 1.58 3.76 1.517 c 1.412 -0.057 2.734 -0.717 3.627 -1.812 l 7.434 -9.108 c 1.662 -2.037 4.124 -3.234 6.751 -3.284 c 2.669 -0.075 5.135 1.052 6.873 3.022 l 23.497 26.636 c 0.322 0.365 0.5 0.836 0.5 1.323 C 81.844 77.117 79.167 79.794 75.877 79.794 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 31.594 45.879 c -4.49 0 -8.142 -3.652 -8.142 -8.142 c 0 -4.489 3.652 -8.142 8.142 -8.142 c 4.489 0 8.142 3.652 8.142 8.142 C 39.736 42.227 36.083 45.879 31.594 45.879 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 88 67.671 c -1.104 0 -2 -0.896 -2 -2 V 16.173 c 0 -1.084 -0.882 -1.967 -1.967 -1.967 h -69.91 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 69.91 c 3.29 0 5.967 2.677 5.967 5.967 v 49.498 C 90 66.775 89.104 67.671 88 67.671 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIcon);
export default __webpack_public_path__ + "static/media/img_icon.f4c8f20ca55c0d36cb6a6f1312a8a273.svg";
export { ForwardRef as ReactComponent };